import { ExportFile, BatchExportState } from './ManageLuckyNumbersExport';
import {
  Card,
  CardContent,
  Button,
  Typography,
  Divider,
  Box,
} from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { ExportManagerModal } from './ExportManagerModal';
import moment from 'moment';
import { useState } from 'react';

interface BatchBoxProps {
  inputProofType?: string;
  inputConfigurationId: string;
  inputBatchId: string;
  inputBatchOrder: number;
  setExports: React.Dispatch<React.SetStateAction<BatchExportState>>;
  inputBatchTotalAvailable?: number;
  inputBatchTotalAmount?: number;
  inputExport: ExportFile[];
  exportInProgress: boolean;
}

export default function BatchBox({
  inputConfigurationId,
  inputProofType,
  setExports,
  inputBatchId,
  inputBatchOrder,
  inputBatchTotalAvailable,
  inputBatchTotalAmount,
  inputExport,
  exportInProgress,
}: BatchBoxProps) {
  const [modalOpen, setModalOpen] = useState(false);

  const prefix = `dataExporter/mechanicSpecificExports/${inputConfigurationId}#${inputBatchId}/completedExports/`;

  const exportTimestamps = (inputExport || [])
    .map((file) => {
      const fileName = file.key.replace(prefix, '');
      const match = fileName.match(/^(\d+)_winners_export\.csv$/);
      return match ? Number(match[1]) : null;
    })
    .filter((ts): ts is number => ts !== null)
    .sort((a, b) => b - a);

  const latestExportDate = exportTimestamps.length
    ? moment(exportTimestamps[0]).format('YYYY-MM-DD HH:mm:ss')
    : null;

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const handleDownload = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <StyledEngineProvider injectFirst>
      <Card sx={{ maxWidth: '400px' }}>
        <CardContent className="campaignCardContent">
          <Box className="promotionNameWrapper">
            <Typography variant="h6" className="promotionNameLabelStyles">
              Batch {inputBatchOrder}
            </Typography>
            <Box className="actionBtnsWrapper">
              <Button
                data-testid={`manage-campaign-button`}
                variant="contained"
                className="manageButtonStyles"
                size="small"
                onClick={handleOpenModal}
              >
                Exports
              </Button>
            </Box>
          </Box>
          <Typography variant="body2" className="promotionIdLabelStyles">
            Batch ID: {inputBatchId}
          </Typography>
          <Typography variant="body2" className="digitalExperienceStyles">
            Lucky Numbers Remaining: {inputBatchTotalAvailable}/{inputBatchTotalAmount}
          </Typography>
        </CardContent>
        <Divider variant="middle" />
        <div className="cardFooter">
          <Box>
            <Typography sx={{ fontSize: '13px', color: '#20673cff', textAlign: 'right' }}>
              {exportInProgress
                ? 'Export in progress...'
                : latestExportDate
                  ? `Latest Export - ${latestExportDate}`
                  : 'No exports yet'}
            </Typography>
          </Box>
        </div>
      </Card>
      {modalOpen && (
        <ExportManagerModal
          inputProofType={inputProofType}
          inputConfigurationId={inputConfigurationId}
          inputBatchId={inputBatchId}
          modalOpen={modalOpen}
          setExports={setExports}
          handleCloseModal={handleCloseModal}
          inputBatchOrder={inputBatchOrder}
          exportInProgress={exportInProgress}
          exports={inputExport || []}
          handleDownload={handleDownload}
        />
      )}
    </StyledEngineProvider>
  );
}

export { BatchBox };
